import { render } from "./GlobalNavigation.vue?vue&type=template&id=191c640d"
import script from "./GlobalNavigation.vue?vue&type=script&lang=js"
export * from "./GlobalNavigation.vue?vue&type=script&lang=js"

import "./GlobalNavigation.vue?vue&type=style&index=0&id=191c640d&lang=scss"

import exportComponent from "/Users/yanislav.pavlov/development/private/bulgartabac/bulgartabac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__